/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PlugIcon = ({ width = 24, height = 24, hidden = false, title = 'Plug' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M3.355 25.983a6.119 6.119 0 0 1 0-8.653l5.288-5.288-.034-.034a2.719 2.719 0 0 1 0-3.846l1.923-1.923a2.719 2.719 0 0 1 3.846 0L16.3 8.162l6.523-6.523a1.02 1.02 0 0 1 1.442 0l1.442 1.442a1.02 1.02 0 0 1 0 1.442l-6.524 6.524 5.769 5.769 6.524-6.524a1.02 1.02 0 0 1 1.442 0l1.442 1.442a1.02 1.02 0 0 1 0 1.442L27.838 19.7l1.923 1.923a2.719 2.719 0 0 1 0 3.846l-1.923 1.923a2.719 2.719 0 0 1-3.846 0l-.059-.059-5.288 5.287a6.118 6.118 0 0 1-8.653 0Z"
    />
  </svg>`;
};
